import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const treatments = [{
  id: 1,
  title: "Back Pain Treatment",
  description: "Evidence-based physiotherapy for chronic and acute back pain, helping you regain mobility and reduce discomfort.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/back_pain_treatment.png"
}, {
  id: 2,
  title: "Knee Osteoarthritis Management",
  description: "Tailored rehabilitation programs to manage knee osteoarthritis symptoms and improve joint function.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/knee_osteoarthritis_management.png"
}, {
  id: 3,
  title: "Shoulder Pain Rehabilitation",
  description: "Comprehensive assessment and treatment for shoulder injuries, rotator cuff issues, and frozen shoulder.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/shoulder_pain_rehabilitation.png"
}, {
  id: 4,
  title: "Sports Injury Treatment",
  description: "Specialized care for athletes and active individuals, supporting recovery and preventing future injuries.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/sports_injury_treatment.png"
}];
export default function OurSpecialisedTreatments() {
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center animate-fade-in-up">
          <h2 className="mb-4 font-display text-3xl font-bold tracking-wide text-foreground md:text-4xl">
            Our Specialised Treatments
          </h2>
          <p className="mx-auto max-w-2xl text-base leading-relaxed text-muted-foreground">
            At Align Physiotherapy, we offer expert, evidence-based care for a
            range of musculoskeletal conditions. Our personalised treatment
            plans are designed to help you move better, feel better, and get
            back to doing what you love.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2 lg:gap-8">
          {treatments.map((treatment, i) => <Card key={treatment.id} data-index={i} className="group overflow-hidden border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium animate-fade-in-up">
              <div className="overflow-hidden">
                <img src={treatment.image} alt={treatment.title} className="h-48 w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-105" />
              </div>
              <CardHeader>
                <CardTitle className="text-xl font-semibold text-foreground">
                  {treatment.title}
                </CardTitle>
                <CardDescription className="text-sm text-muted-foreground">
                  {treatment.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Link to="/ConditionsPage">
                  <Button variant="outline" className="group/btn w-full transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
                    Learn More
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </Link>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-12 text-center animate-fade-in-up-delay-200">
          <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
            <Button size="lg" className="shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-strong">
              Book an Appointment
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}